import React from 'react';
import cx from 'classnames';
import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import { withTranslate } from 'shared/hocs/withTranslate';
import { ByParamsValidation } from 'shared/helpers/insuranceFormValidation';
import FormSelect from 'shared/components/insurance/components/FormSelect/FormSelect';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ByParamsForm.css';

const isMobile = __APP__ === 'mobile';

class ByParamsForm extends React.Component {
  static propTypes = {
    regions: PropTypes.arrayOf(PropTypes.shape()),
    filters: PropTypes.shape(),
    handleRegionChange: PropTypes.func,
    setFieldValue: PropTypes.func,
    handleSubmit: PropTypes.func,
    errors: PropTypes.shape(),
    touched: PropTypes.shape(),
    values: PropTypes.shape(),
    //
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    regions: null,
    handleRegionChange: () => {},
    setFieldValue: () => {},
    handleSubmit: () => {},
    errors: {},
    touched: {},
    values: {},
    filters: {},
  };
  render() {
    const {
      filters,
      handleRegionChange,
      setFieldValue,
      regions,
      handleSubmit,
      errors,
      touched,
      values,
      t,
    } = this.props;

    const { transport_type: transportType, dgo } = filters;
    const disabledBtn = !values.transport_type || !values.region || !values.dgo;

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className={s.mainform}>
            <FormSelect
              customStyle={isMobile ? '' : s.filterItem}
              value={values.transport_type}
              handleChange={setFieldValue}
              fieldName="transport_type"
              options={transportType && transportType.values ? transportType.values : []}
              label={t('Тип ТС')}
              clearable={false}
              errors={errors}
              touched={touched}
            />
            <FormSelect
              customStyle={isMobile ? '' : s.filterItem}
              value={values.region}
              onInputChange={handleRegionChange}
              handleChange={setFieldValue}
              fieldName="region"
              options={regions || []}
              label={t('Регистрация владельца ТС')}
              clearable={false}
              errors={errors}
              touched={touched}
            />
            <FormSelect
              customStyle={isMobile ? '' : s.filterItem}
              value={values.dgo}
              handleChange={setFieldValue}
              fieldName="dgo"
              options={dgo.values || []}
              label={t('ДГО')}
              clearable={false}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className={s.buttonContainer}>
            <div className={s.buttonBlock}>
              <button
                disabled={disabledBtn}
                className={cx(s.button, { [s.disabledBtn]: disabledBtn })}
                type="submit"
                data-lens-event={'carCostCalcClick'}
              >
                {t('Рассчитать стоимость')}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(withFormik(ByParamsValidation)(ByParamsForm)));



// WEBPACK FOOTER //
// ./src/desktop/routes/home/components/Insurance/ByParamsForm/ByParamsForm.js